// extracted by mini-css-extract-plugin
export default {"wrapper":"kQRp9","switch-wrapper":"llVq3","switch":"DGVZf","title":"bBEBj","main-title":"cLpVd","sub-title":"knwXi","price":"evTHD","price-hint":"wAhlm"};